import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants"

const API_CONTROLLER = "messages";

export class MessageApi {
    static getMessageList(wardId, pagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message-search`;
        return authAxios.post(url, pagingInfo);
    }

    static getMessageInboundList(wardId, pagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/inbound-message-search`;
        return authAxios.post(url, pagingInfo);
    }

    static getMessage(wardId, messageId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/${messageId}`;
        return authAxios.get(url);
    }

    static createMessage(wardId, messageInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message`;
        return authAxios.post(url, messageInfo);
    }

    static getMessageNotes(wardId, messageId, pagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/${messageId}/notes`;
        return authAxios.post(url, pagingInfo);
    }

    static getMessageContacts(wardId, messageId, pagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/${messageId}/contacts`;
        return authAxios.post(url, pagingInfo);
    }

    static updateMessage(wardId, messageId, messageInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/${messageId}`;
        return authAxios.put(url, messageInfo);
    }

    static validateMessageText(messageInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/validate`;
        return authAxios.post(url, messageInfo)
    }

}